module.exports = __webpack_public_path__ + "img/sysmex.fe8707b6.png";